import { render, staticRenderFns } from "./GroupsList.vue?vue&type=template&id=2c3cb823&scoped=true&"
import script from "./GroupsList.vue?vue&type=script&lang=js&"
export * from "./GroupsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3cb823",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c3cb823')) {
      api.createRecord('2c3cb823', component.options)
    } else {
      api.reload('2c3cb823', component.options)
    }
    module.hot.accept("./GroupsList.vue?vue&type=template&id=2c3cb823&scoped=true&", function () {
      api.rerender('2c3cb823', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/management/vistas/components/GroupsList.vue"
export default component.exports